//randfilename
export const randFileName = () => {
	let rFileName = 'ps_img';
	let alphas = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];

	for(let i =0; i<9; i++){
		rFileName += alphas[ Math.round( Math.random() * 25 ) ]
	}
	return (rFileName + '.jpg');
}